module.exports = __webpack_public_path__ + "static/media/pluscircle.ce345506.svg";